/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/9/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {LocationItem} from "@shared/scheduler/LocationItem";
import {Type} from "@qwoach/class-transformer-wrapper";
import dayjs from "dayjs";
import {SessionConfirmationStatus} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";

export default class ScheduledSessionRef extends BaseObject {

	id: string = null

	@Type(() => LocationItem)
	location: LocationItem = null

	startTime: number = null
	duration: number = null

	confirmationStatus: SessionConfirmationStatus = null


	constructor() {
		super();
	}

	endTime(){
		return this.startTime + this.duration
	}


	startDateFormatted(){
		return dayjs(new Date(this.startTime)).format("dddd, MMM DD");
	}
	endDateFormatted(){
		return dayjs(new Date(this.endTime())).format("dddd, MMM DD");
	}
	startTimeFormatted(){
		return dayjs(this.startTime).format("hh:mma");
	}
	endTimeFormatted(){
		return dayjs(this.endTime()).format("hh:mma");
	}
	isCompleted(){
		return this.startTime + this.duration < new Date().getTime()
	}

	isSessionConfirmed(){
		return this.confirmationStatus === SessionConfirmationStatus.CONFIRMED
	}

	isSessionCancelled(){
		return this.confirmationStatus === SessionConfirmationStatus.CANCELLED
	}



	syncFromSession(scheduledSession){
		this.id = scheduledSession.id
		this.location = scheduledSession.location
		this.startTime = scheduledSession.startTime
		this.duration = scheduledSession.duration
		this.confirmationStatus = scheduledSession.confirmationStatus
	}

}

